import { defineMessages } from 'react-intl';

export default defineMessages({
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
  toastIntervenantTitle: {
    id:
      'administration.platform_manager.manager_management.add_intervenant_toast',
  },
  titleUpdateDrawer: {
    id:
      'administration.platform_manager.manager_management.title_update_drawer',
  },
  LawyerInfoTitle: {
    id: 'administration.platform_manager.manager_management.lawyer_info_title',
  },
  jurisdiction: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  intervalWorkTitle: {
    id:
      'administration.platform_manager.manager_management.interval_work_title',
  },
  selectIntervalWorkTitle: {
    id:
      'administration.platform_manager.manager_management.select_interval_work_title',
  },
  cancelButtonTitle: {
    id: 'saham_dialog.cancel',
  },
  addButtonTitle: {
    id: 'add.title',
  },
  selectedIntervalWorkTitle: {
    id:
      'administration.platform_manager.manager_management.selected_interval_work_title',
  },
  successUpdateTitle: {
    id: 'administration.platform_manager.manager_management.update_info.title',
  },
  jurisdictionTitle: {
    id:
      'legal_proceeding_page.judgement_add.procedure_information.jurisdiction.title',
  },
  searchTitle: {
    id: 'expert_search_container.title',
  },
  searchSubTitle: {
    id: 'expert_search_container.subtitle',
  },
  lawyerTitle: {
    id: 'global_provision.stake_holder.lawyer',
  },
  intervenantTitle: {
    id: 'administration.platform_manager.intervenant.title',
  },
  linesPerPage: {
    id: 'lines_per_page',
  },
  jurisdictionTableTitle: {
    id: 'administration.platform_manager.intervenant.jurisdiction_title',
  },
  intervernantTableTitle: {
    id: 'administration.platform_manager.intervenant.intervenant_title',
  },
  timeIntervalTitle: {
    id: 'administration.platform_manager.intervenant.time_interval_title',
  },
  totalDaysTitle: {
    id: 'administration.platform_manager.intervenant.total_days_title',
  },
  actionTitle: {
    id: 'action.title',
  },
  updateTitle: {
    id: 'legal_proceeding_page.judgement_add.civil_party.recap.edit_title',
  },
});
